import type { CommonResponse } from '@/utils/request';
import { Request } from '@/utils/request';

export interface IResonance {
  id: number;
  sessionId: string;
  userId: string;
  userName: string;
  label: string;
  greeting: string;
  avatar: string;
  isFriend: boolean;
}

export const getResonance = (data: { noteId: number; refreshSuggest?: boolean }) => {
  return Request<CommonResponse<IResonance[]>>({
    url: `/rest/os/resonance/get/by/noteId`,
    method: 'get',
    params: { noteId: data.noteId, refreshSuggest: data.refreshSuggest ?? false }
  });
};

export const getChatResonance = (data: { sessionId: string; refreshSuggest?: boolean }) => {
  return Request<CommonResponse<IResonance[]>>({
    url: `/rest/os/resonance/get/by/noteId`,
    method: 'get',
    params: { sessionId: data.sessionId, refreshSuggest: data.refreshSuggest ?? false }
  });
};

export const createSessionByResonance = (data: { resonanceId: number }) => {
  return Request<CommonResponse<{ sessionId: string }>>({
    url: `/rest/general/session/create/by/resonance`,
    method: 'post',
    data
  });
};
